import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./VideoModal.css";

/**
 * VideoModal component - Reusable video modal for desktop and mobile
 * 
 * @param {boolean} isOpen - Controls modal visibility
 * @param {function} onClose - Callback to close the modal
 * @param {string} videoUrl - YouTube embed URL (with or without autoplay)
 */
function VideoModal({ isOpen, onClose, videoUrl = "https://www.youtube.com/embed/scPk5PA-_Ec?autoplay=1" }) {
  // Lock scroll when the video modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }

    // Clean up when component unmounts
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, [isOpen]);

  // Handle ESC key to close modal
  useEffect(() => {
    if (!isOpen) return;

    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  // Don't render anything if modal is not open
  if (!isOpen) return null;

  // Build the video overlay as a portal to <body>
  return createPortal(
    <div className="hero-video-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        className="hero-video-dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="hero-video-frame-wrapper">
          <iframe
            src={videoUrl}
            title="DocuHounds Video Demo"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
          />
        </div>

        <button
          type="button"
          className="hero-video-close"
          onClick={onClose}
          aria-label="Close video"
        >
          ×
        </button>
      </div>
    </div>,
    document.body
  );
}

export default VideoModal;
